/* eslint-disable */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as AppActions from '../../actions';
import { getCarousels, removeCarousel } from '../../services/CarouselService';
import CarouselList from './CarouselList';
import CarouselBuilder from './CarouselBuilder';
import './CarouselSearch.css';

class CarouselSearch extends Component {
  state = {
    token: this.props.getFbToken(),
    carousels: null,
    section: 'search'
  };

  componentDidMount() {
    this.props.setSectionTitle('Carousel Tool');
    this.props.saveGTMEvent('Carousel Tool', 'Alexia');
    this.getCarousels();
  }

  getCarousels = async () => {
    const carousels = await getCarousels();
    this.setState({ carousels });
  };

  newCarousel = () => {
    this.setState({ section: 'newCarousel', carouselToEdit: '' });
  };

  searchPage = () => {
    this.setState({ section: 'search' });
    this.getCarousels();
  };

  deleteCarousel = async (id) => {
    const result = await removeCarousel(id);
    this.getCarousels();
  };

  editCarousel = (id) => {
    const carousel = this.state.carousels.carousels.find(
      (item) => item.id === id
    );
    this.setState({ section: 'newCarousel', carouselToEdit: carousel });
  };

  render() {
    const { carousels } = this.state;
    if (carousels) {
      return (
        <div className="container">
          {this.state.section === 'search' ? (
            <CarouselList
              carousels={this.state.carousels}
              newCarousel={this.newCarousel}
              deleteCarousel={this.deleteCarousel}
              editCarousel={this.editCarousel}
            />
          ) : null}
          {this.state.section === 'newCarousel' ? (
            <CarouselBuilder
              searchPage={this.searchPage}
              getFbToken={this.props.getFbToken}
              carouselToEdit={this.state.carouselToEdit}
            />
          ) : null}
        </div>
      );
    }
    return null;
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CarouselSearch);



// WEBPACK FOOTER //
// ./src/screens/Carousel/CarouselSearch.js